<template>
    <v-dialog v-model="shows" width="400" content-class="rounded-xl" :persistent="loading">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-bind="{ loading }">
            <v-card-title>수동 보고서 생성</v-card-title>
            <v-card-text>
                <v-row class="ma-n2">
                    <v-col cols="6" class="pa-2">
                        <v-text-field v-model="form.year" type="number" min="2023" max="2099" v-bind="attrs_input" suffix="년" class="text-caption" />
                    </v-col>
                    <v-col cols="6" class="pa-2">
                        <v-text-field v-model="form.month" type="number" min="1" max="12" v-bind="attrs_input" suffix="월" class="text-caption" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn v-bind="{ loading }" text color="red" @click="shows = false">취소하기</v-btn>
                <v-btn v-bind="{ loading }" text color="primary" @click="save">생성하기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import dayjs from "@/plugins/vue-dayjs";
import { attrs_input } from "@/assets/variables";

const initForm = (form = {}) => ({
    ...form,

    type: "MONTHLY",
    year: form?.year ?? dayjs.tz().year(),
    month: form?.month ?? dayjs.tz().subtract(1, "month").month() + 1,
});

export default {
    props: {
        value: { type: Object, default: initForm },
    },
    data: () => ({
        form: initForm(),

        shows: false,
        loading: false,

        attrs_input,
    }),
    methods: {
        sync() {
            this.form = initForm(this.value);
        },
        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { ...form } = this.form;
                form.month -= 1;

                const { report } = await api.console.recruitments.reports.post(form);
                this.shows = false;

                this.$emit("input", report);
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        value() {
            this.sync();
        },
        shows() {
            if (this.shows) this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
